// @flow

export type WidgetChrome = 'embedded';

export const WIDGET_CHROME: { [key: string]: WidgetChrome } = {
  EMBEDDED: 'embedded',
};

export type WidgetScheduling = 'in_widget';

export const WIDGET_SCHEDULING: { [key: string]: WidgetScheduling } = {
  IN_WIDGET: 'in_widget',
};

export const CASH_PAYMENT_ID = 'lm_xxxxxxx';
export const OTHER_ID = '';

export type InsuranceCoverageStatus =
  | 'UNKNOWN'
  | 'CASH_PAYMENT'
  | 'OTHER'
  | 'IN_NETWORK'
  | 'WILL_FILE'
  | 'WILL_NOT_FILE';

export const INSURANCE_COVERAGE_STATUS: { [key: string]: InsuranceCoverageStatus } = {
  UNKNOWN: 'UNKNOWN',
  CASH_PAYMENT: 'CASH_PAYMENT',
  OTHER: 'OTHER',
  IN_NETWORK: 'IN_NETWORK',
  WILL_FILE: 'WILL_FILE',
  WILL_NOT_FILE: 'WILL_NOT_FILE',
};

export type AppointmentStatus =
  | 'UNVERIFIED'
  | 'UNAVAILABLE'
  | 'PENDING'
  | 'SCHEDULED'
  | 'CONFLICTED'
  | 'CONFIRMED'
  | 'PATIENT_CANCELED'
  | 'SYSTEM_CANCELED'
  | 'MISSED'
  | 'COMPLETED'
  | 'NOT_SCHEDULED';

export const APPOINTMENT_STATUS: { [key: string]: AppointmentStatus } = {
  UNVERIFIED: 'UNVERIFIED',
  UNAVAILABLE: 'UNAVAILABLE',
  PENDING: 'PENDING',
  SCHEDULED: 'SCHEDULED',
  CONFLICTED: 'CONFLICTED',
  CONFIRMED: 'CONFIRMED',
  PATIENT_CANCELED: 'PATIENT_CANCELED',
  SYSTEM_CANCELED: 'SYSTEM_CANCELED',
  MISSED: 'MISSED',
  COMPLETED: 'COMPLETED',
  NOT_SCHEDULED: 'NOT_SCHEDULED',
};

export type ReasonForVisitId = 'select' | ?string;

export const REASON_FOR_VISIT = {
  SELECT: 'select',
};

export type PatientStatus = 'NEW' | 'RETURNING';

export const PATIENT_STATUS: { [key: string]: PatientStatus } = {
  NEW: 'NEW',
  RETURNING: 'RETURNING',
};

export type Role = 'ADMINISTRATOR' | 'PATIENT' | 'PROVIDER' | 'PRACTICE_MANAGER';

export const ROLE: { [key: string]: Role } = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  PATIENT: 'PATIENT',
  PROVIDER: 'PROVIDER',
  PRACTICE_MANAGER: 'PRACTICE_MANAGER',
};

export const DATE_REPRESENTATION = {
  NARROW: 'narrow',
  SHORT: 'short',
  LONG: 'long',
  NUMERIC: 'numeric',
  TWO_DIGIT: '2-digit',
};

export const DATE_TIME_FORMAT = {
  FULL: {
    year: DATE_REPRESENTATION.NUMERIC,
    month: DATE_REPRESENTATION.SHORT,
    day: DATE_REPRESENTATION.NUMERIC,
    hour: DATE_REPRESENTATION.NUMERIC,
    minute: DATE_REPRESENTATION.NUMERIC,
    timeZoneName: DATE_REPRESENTATION.SHORT,
  },
};

export const DATE_FORMAT = {
  MEDIUM_NO_YEAR: {
    month: DATE_REPRESENTATION.LONG,
    day: DATE_REPRESENTATION.NUMERIC,
  },
  SHORT: {
    month: DATE_REPRESENTATION.SHORT,
    day: DATE_REPRESENTATION.TWO_DIGIT,
    year: DATE_REPRESENTATION.NUMERIC,
  },
  LONG: {
    weekday: DATE_REPRESENTATION.LONG,
    month: DATE_REPRESENTATION.SHORT,
    day: DATE_REPRESENTATION.TWO_DIGIT,
    year: DATE_REPRESENTATION.NUMERIC,
  },
};

export const TIME_FORMAT = {
  LONG: {
    hour: DATE_REPRESENTATION.NUMERIC,
    minute: DATE_REPRESENTATION.NUMERIC,
    timeZoneName: DATE_REPRESENTATION.SHORT,
  },
};

export const FLASH_MESSAGES = Object.freeze({
  SCHEDULED: 'scheduled',
  CONFIRMED: 'confirmed',
  OPENING_NOT_AVAILABLE: 'opening_not_available',
});

export type FlashMessage = $Values<typeof FLASH_MESSAGES>;
